import { render } from "./agent.vue?vue&type=template&id=90d7cc8e&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"

import "./agent.vue?vue&type=style&index=0&id=90d7cc8e&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d7cc8e"]])

export default __exports__